import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const DetailStudent = () => {
  const [studentData, setStudentData] = useState([]);
  const [schoolOption, setSchoolOption] = useState([]);
  const [classOption, setClassOption] = useState([]);
  const [studentPoints, setStudentPoints] = useState([]);

  const breadcrumb = {
    current_section: "Studenti",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Classi", route_name: null, params: [] },
      { name: "Studenti", route_name: null, params: [] },
      { name: "Modifica", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchoolOption(
          convertIntoSelect2Options(result.return.scuola, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchStudentData = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getStudent?studentId=${window.location.href.split("/").pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setStudentData(result);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchStudentPoints = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/app/profile/challengesHistory?userId=${window.location.href
            .split("/")
            .pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setStudentPoints(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchools();
    fetchStudentData();
    fetchStudentPoints();
  }, []);

  const handleAvatarChange = (e) => {};

  useEffect(() => {
    handleImportSchoolChange(studentData.idscuole);
  }, [studentData.idscuole]);

  const handleImportSchoolChange = (id) => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola/classi?idscuola=${id}&annoscolastico=20242025`,
          fetchOptions
        );
        const result = await response.json();
        setClassOption(
          customConvertIntoSelect2OptionsClasses(
            result.return.classi,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchSchools();
  };

  const handleSchoolChange = async (event) => {
    try {
      const fetchOptions = getFetchOptions(
        "application/x-www-form-urlencoded",
        [],
        "GET"
      );
      const response = await fetch(
        `${axios.defaults.baseURL}/scuola/classi?idscuola=${event?.value}&annoscolastico=20242025`,
        fetchOptions
      );
      const result = await response.json();
      setClassOption(
        customConvertIntoSelect2OptionsClasses(
          result.return.classi,
          "idclassi",
          "classe",
          "sezione"
        )
      );
      setStudentData({ ...studentData, idscuola: event?.value });
    } catch (error) {
      console.error(error);
    }
  };

  const handleClassChange = (event) => {
    setStudentData({ ...studentData, idclasse: event?.value });
  };

  const handleEmailValidation = async () => {
    try {
      const fetchOptions = getFetchOptions(
        "application/json",
        { email: studentData.email },
        "POST"
      );
      const response = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/sendVerificationEmail`,
        fetchOptions
      );
      const result = await response.json();
      if (!result.error) {
        alert("Email di validazione inviata con successo!");
      } else {
        alert("Errore nell'invio dell'email.");
      }
    } catch (error) {
      console.error("Errore durante l'invio dell'email:", error);
      alert("Errore durante l'invio dell'email.");
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a
        href={`/students?schoolId=${studentData.idscuole}&classId=${studentData.idclasse}`}
      >
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista studenti
        </button>
      </a>

      <div className="card custom-card">
        <div className="card-header">Immagine del profilo</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-2 align-items-center">
            {studentData.image && (
              <span
                className="avatar mx-3 mb-3 mb-lg-0"
                style={{ backgroundImage: `url(${studentData.image})` }}
              ></span>
            )}
          </div>
        </div>
      </div>

      {/* Student Data Form */}
      <div className="card custom-card">
        <div className="card-header">Dati studente</div>
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-lg-3">
              <label htmlFor="school">Scuola</label>
              <Select
                options={schoolOption}
                id="school"
                name="school"
                value={schoolOption?.filter(function (option) {
                  return option.value === studentData.idscuole;
                })}
                onChange={handleSchoolChange}
                classNames={"form-control"}
                placeholder="Scegli scuola..."
                isSearchable
                isClearable
                isDisabled
              />
            </div>

            <div className="col-12 col-lg-3">
              <label htmlFor="classe">Classe</label>
              <Select
                options={classOption}
                id="classe"
                name="classe"
                value={classOption?.filter(function (option) {
                  return option.value === studentData.idclasse;
                })}
                onChange={handleClassChange}
                classNames={"form-control"}
                placeholder="Scegli classe..."
                isSearchable
                isClearable
                isDisabled
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="nome">Nome</label>
                <input
                  className="form-control"
                  id="nome"
                  name="nome"
                  value={studentData?.nome || ""}
                  onChange={(e) =>
                    setStudentData({ ...studentData, nome: e.target.value })
                  }
                  disabled
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="cognome">Cognome</label>
                <input
                  className="form-control"
                  id="cognome"
                  name="cognome"
                  value={studentData?.cognome || ""}
                  onChange={(e) =>
                    setStudentData({ ...studentData, cognome: e.target.value })
                  }
                  disabled
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="codicefiscale">Codice Fiscale</label>
                <input
                  className="form-control"
                  id="codicefiscale"
                  name="codicefiscale"
                  value={studentData?.codicefiscale || ""}
                  onChange={(e) =>
                    setStudentData({
                      ...studentData,
                      codicefiscale: e.target.value,
                    })
                  }
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="birthDate">Data di nascita</label>
                <input
                  className="form-control"
                  type="date"
                  id="birthDate"
                  name="birthDate"
                  value={studentData?.birthdate || ""}
                  onChange={(e) =>
                    setStudentData({
                      ...studentData,
                      birthdate: e.target.value,
                    })
                  }
                  disabled
                />
              </div>
            </div>

            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <div className="input-group">
                  <input
                    className="form-control"
                    type="email"
                    id="email"
                    name="email"
                    value={studentData?.email || ""}
                    onChange={(e) =>
                      setStudentData({ ...studentData, email: e.target.value })
                    }
                    disabled
                  />
                  <button
                    className="btn btn-primary"
                    onClick={handleEmailValidation}
                    disabled={studentData?.email_validated == 1}
                  >
                    {studentData?.email_validated == 1 ? "Validata" : "Valida"}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  value={studentData?.telefono || ""}
                  onChange={(e) =>
                    setStudentData({
                      ...studentData,
                      telefono: e.target.value,
                    })
                  }
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modular Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>Dati correlati</span>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <label htmlFor="class">Challenges</label>
              <div className="tableContainer mt-3">
                <table className="classesTable table table-bordered">
                  <thead>
                    <tr>
                      <th>Challenge</th>
                      <th>Punti</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!studentPoints ??
                      studentPoints?.map((challenge, index) => {
                        const totalPoints = challenge.points.reduce(
                          (sum, point) => sum + point.value,
                          0
                        );
                        return (
                          <tr key={index}>
                            <td>{challenge.challengeTitle}</td>
                            <td>{totalPoints}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailStudent;
